import { ReactElement, useCallback, useEffect, useRef } from 'react';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import {
  handleFormAfterSubmit,
  handleFormPreSubmit,
  postFormSubmit,
} from '../../../utils/formHelpers';
import useFallbackTranslation from '../../../utils/hooks/useFallbackTranslation';
import { useBasket } from '../BasketContext/useBasket';

const EmailCart = (): ReactElement | null => {
  const { t } = useFallbackTranslation();
  const { sitecoreContext } = useSitecoreContext();
  const { basket, isEmailCartOpen, isEmailCartSubmitted, submitEmailCart, createNewSharedBasket } =
    useBasket();

  const iframeRef = useRef<HTMLIFrameElement>(null);

  const preSubmitEmailCart = useCallback(async () => {
    const customObjectKey = await createNewSharedBasket();
    postFormSubmit(iframeRef, customObjectKey);
  }, [createNewSharedBasket]);

  useEffect(() => {
    if (!basket?.basket_id) return;

    const preSubmitHandler = handleFormPreSubmit(preSubmitEmailCart);
    window.addEventListener('message', preSubmitHandler);

    return () => {
      window.removeEventListener('message', preSubmitHandler);
    };
  }, [basket, preSubmitEmailCart]);

  useEffect(() => {
    const postSubmitHandler = handleFormAfterSubmit(submitEmailCart);
    window.addEventListener('message', postSubmitHandler);

    return () => {
      window.removeEventListener('message', postSubmitHandler);
    };
  }, [submitEmailCart]);

  return isEmailCartOpen ? (
    <div className="absolute left-0 right-0 top-16 block border-b border-gray-300 bg-gray-50 p-5 font-semibold normal-case">
      {!isEmailCartSubmitted ? (
        <>
          <div>{t('cart.EmailBasketHeader')}</div>
          <div>{t('cart.EmailBasketSubHeader')}</div>
          <iframe
            ref={iframeRef}
            title="email-cart"
            className="mt-4 h-28 w-full"
            src={`/${sitecoreContext.language}/forms/email-cart`}
          />
        </>
      ) : (
        <div>{t('cart.EmailBasketThankYou')}</div>
      )}
    </div>
  ) : null;
};

export default EmailCart;
